import {
    defineMessages,
} from 'react-intl';
import { Settings, SupportedSettings } from "../../../settings/account/Settings.jsx";

const messages = defineMessages({
    "created_at": {
        id: 'invoice.listing.filters.date.created_at',
        defaultMessage: 'Created date',
    },
    "updated_at": {
        id: 'invoice.listing.filters.date.updated_at',
        defaultMessage: 'Updated date',
    },
    "most_used_filters": {
        id: "invoice.listing.headers.most_used_filters",
        defaultMessage: "Most used filters",
    },
    "is_archived": {
        id: "invoice.listing.headers.show_archived",
        defaultMessage: "Show archived",
    },
    "product_label": {
        id: "invoice.listing.headers.product_label",
        defaultMessage: "Product label",
    },
    "product_title": {
        id: "invoice.listing.headers.product_title",
        defaultMessage: "Product title",
    },
    "product_manufacturer_sku": {
        id: "invoice.listing.headers.product_manufacturer_sku",
        defaultMessage: "Product Manufacturer sku",
    },
    "product_sku": {
        id: "invoice.listing.headers.product_sku",
        defaultMessage: "Product sku",
    },
    "short_description": {
        id: "product.listing.headers.product_short_description",
        defaultMessage: "Product Short Description",
    },
    "barcode": {
        id: "product.listing.headers.barcode",
        defaultMessage: "Product Barcode",
    },
    "default_price": {
        id: "product.listing.headers.default_price",
        defaultMessage: "Product Price",
    },
})

export const productTotals = []

export const getProductFields = (settings, supportedSettings) => {
    let fields = [
        'title',
        'titleKeyword',
        'titleAnalyzed',
        'titleSort',
        'sku',
        'manufacturerSku',
        'manufacturerSkuKeyword',
        'manufacturerSkuText',
        'skuKeyword',
        'skuText',
        'upc',
        'ean',
        'barcode',
    ]

    if (settings.get(supportedSettings.ShowShortDescriptionInListing)) {
        fields = fields.concat([
            'shortDescription',
            'shortDescriptionKeyword',
            'shortDescriptionAnalyzed',
            'shortDescriptionSort',
        ])
    }
    return fields
}

export const productFields = getProductFields(Settings, SupportedSettings)

export const getProductsFilters = function (context, includeProductPrice = false) {
    var filtersToUse =
        [
            {
                section: context.intl.formatMessage(messages["most_used_filters"]),
            },
            {
                nameId: 'isArchived',
                label: context.intl.formatMessage(messages["is_archived"]),
                filterMatch: 'isArchived',
                type: 'boolean',
                placeHolder: 'Show archived',
                initialValue: '',
                initialSelect: 'is',
            },
            {
                nameId: "titleKeyword",
                label: context.intl.formatMessage(messages["product_title"]),
                filterMatch: 'titleKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: "skuKeyword",
                label: context.intl.formatMessage(messages["product_sku"]),
                filterMatch: 'skuKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: "manufacturerSkuKeyword",
                label: context.intl.formatMessage(messages["product_manufacturer_sku"]),
                filterMatch: 'manufacturerSkuKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: "labelIds",
                label: context.intl.formatMessage(messages["product_label"]),
                filterMatch: 'labelIds',
                type: 'select',
                typeOfSelect: 'product-label-select',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'updatedAt',
                label: context.intl.formatMessage(messages["updated_at"]),
                filterMatch: 'updatedAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: "shortDescriptionKeyword",
                label: context.intl.formatMessage(messages["short_description"]),
                filterMatch: 'shortDescriptionKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: "barcode",
                label: context.intl.formatMessage(messages["barcode"]),
                filterMatch: 'barcode',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
        ]

    if (includeProductPrice) {
        filtersToUse.push({
            nameId: "defaultPrice",
            label: context.intl.formatMessage(messages["default_price"]),
            filterMatch: 'defaultPrice',
            type: 'number',
            initialValue: '',
            initialSelect: 'is'
        })
    }
    return filtersToUse
}




// WEBPACK FOOTER //
// ./src/common/search-filter/search/productsFilters.jsx